import * as React from "react";
import { Col } from "components/bootstrap";
import ConfigletContainer from "pages/configurations/ConfigletContainer";
const ConfigurationSection = ({ ConfigurationComponent, title }) => /* @__PURE__ */ React.createElement(Col, { md: 10 }, /* @__PURE__ */ React.createElement(ConfigletContainer, { title }, /* @__PURE__ */ React.createElement(ConfigurationComponent, null)));
export default ConfigurationSection;
